export function buildEmploymentFormData(formElement) {
    const formData = new FormData();
    const formFields = formElement.querySelectorAll('input, textarea, select');
  
    formFields.forEach(field => {
      if (!field.name) return;
  
      if (field.type === 'radio' && !field.checked) return;
  
      if (field.type === 'file') {
        if (field.files && field.files.length > 0) {
          Array.from(field.files).forEach(file => {
            formData.append(field.name, file);
          });
        }
      } else if (field.type === 'checkbox') {
        formData.append(field.name, field.checked);
      } else if (field.type === 'select-multiple') {
        const selectedValues = Array.from(field.selectedOptions).map(opt => opt.value);
        selectedValues.forEach(value => formData.append(field.name, value));
      } else {
        formData.append(field.name, field.value);
      }
    });
  
    return formData;
  }